export enum PaymentMethodStatus {
  PAYMENT_IN_PROCESS = 'payment_in_process',
  OK = 'ok',
  WARN = 'warn',
  SUSPENDED = 'suspended',
  CANCELLED = 'cancelled',
}
